import React, { useState } from 'react';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
const SingleQusiton = ({ title, info }) => {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <article  data-aos="flip-left"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="2000" className='question'>
      <header>
        <h4>{title}</h4>
        <button className='btn' onClick={() => setShowInfo(!showInfo)}>
          {showInfo ? <AiOutlineMinus /> : <AiOutlinePlus />}
        </button>
      </header>
      {showInfo && <p>{info}</p>}
    </article>
  );
};

export default SingleQusiton;